<nz-modal [(nzVisible)]="showProviderModal"
  (nzOnCancel)="handleCancelModal()"
  nzWidth="800px"
  >
  <div class="modal-content" *nzModalContent>
    <h4>Agrega un proveedor</h4>
    <h5>Información general del proveedor</h5>
    <p>Completa la siguiente información general para poder agregar al proveedor.</p>
    <p>Una vez que lo hayas agregado, podrás completar su información en el catálogo de proveedores.</p>
      <form nz-form class="modal-form"
        [formGroup]="providerForm">
        <div class="modal-column">
          <div class="id-key-container">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="id">ID</nz-form-label>
              <nz-form-control>
                <input nz-input [disabled]="true" id="id" />
              </nz-form-control>
            </nz-form-item>
    
            <nz-form-item>
              <nz-form-label nzRequired nzFor="providerKey">Clave</nz-form-label>
              <nz-form-control nzErrorTip="Clave inválida">
                <input formControlName="providerKey"
                  nz-input placeholder="Escribe la clave"
                  id="providerKey" />
              </nz-form-control>
            </nz-form-item>
          </div>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerRFC">RFC</nz-form-label>
            <nz-form-control nzErrorTip="RFC inválido">
              <input formControlName="providerRFC"
                nz-input placeholder="Escribe el RFC"
                id="providerRFC"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerLegalName">Razón social</nz-form-label>
            <nz-form-control nzErrorTip="Razón social inválida">
              <input formControlName="providerLegalName"
                nz-input placeholder="Escribe la razón social del proveedor"
                id="providerLegalName"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerTypeId">Tipo de proveedor</nz-form-label>
            <nz-form-control nzErrorTip="Tipo de proveedor inválido">
              <nz-select nzPlaceHolder="Selecciona una opción"
                formControlName="providerTypeId" style="width: 100%;"
                id="providerTypeId">
                @for (type of providerTypes; track type) {
                <nz-option [nzLabel]="type.providerTypeName" [nzValue]="+type.providerTypeId"></nz-option>
              }
            </nz-select>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="paymentTypeId">Forma de pago</nz-form-label>
            <nz-form-control nzErrorTip="Forma de pago inválida">
              <nz-select nzPlaceHolder="Selecciona una opción"
                formControlName="paymentTypeId" style="width: 100%;"
                id="paymentTypeId">
                @for (type of paymentTypes; track type) {
                  <nz-option [nzLabel]="type.paymentTypeValue" [nzValue]="+type.paymentTypeId"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="paymentMethodId">Método de pago</nz-form-label>
            <nz-form-control nzErrorTip="Método de pago inválido">
              <nz-select nzPlaceHolder="Selecciona una opción"
                formControlName="paymentMethodId" style="width: 100%;"
                id="paymentMethodId">
                @for (method of paymentMethods; track method) {
                  <nz-option [nzLabel]="method.paymentMethodValue" [nzValue]="+method.paymentMethodId"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
    
        <div class="modal-column">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerShortName">Nombre del proveedor (corto)</nz-form-label>
            <nz-form-control nzErrorTip="Nombre del proveedor (corto) inválido">
              <input formControlName="providerShortName"
                nz-input placeholder="Escribe el nombre del proveedor"
                id="providerShortName"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerFirstName">Nombre(s)</nz-form-label>
            <nz-form-control nzErrorTip="Nombre(s) inválido">
              <input formControlName="providerFirstName"
                nz-input placeholder="Ingresa el nombre del contacto"
                id="providerFirstName"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerLastName">Apellido(s)</nz-form-label>
            <nz-form-control nzErrorTip="Apellido(s) inválido">
              <input formControlName="providerLastName"
                nz-input placeholder="Ingresa el apellido del contacto"
                  name="providerLastName" id="providerLastName"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerTelephone">Teléfono</nz-form-label>
            <nz-form-control nzErrorTip="Teléfono inválido">
              <input formControlName="providerTelephone"
                nz-input placeholder="Ingresa el teléfono de contacto"
                id="providerTelephone"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerEmail">Correo electrónico</nz-form-label>
            <nz-form-control nzErrorTip="Correo electrónico inválido">
              <input formControlName="providerEmail"
                nz-input placeholder="Ingresa el correo electrónico de contacto"
                id="providerEmail"/>
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
  </div>
  <div *nzModalFooter class="modal-footer">
    <button nz-button class="default" (click)="handleCancelModal()">Cancelar</button>
    <button nz-button nzType="primary" (click)="onCreateProvider()" [disabled]="!providerForm.valid">Agregar proveedor</button>
  </div>
</nz-modal>